<div class="modal-header modal_popup p-2 px-3 eMdlHdr">
    <h4 class="cardheading eMdlHdrClr mb-0 pt-0 pb-0">Downloads</h4>
    <button type="button" class="close btn btn-light float-end eMdlClsBtn" (click)="actMdl.close()">
        <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-2">
    <div class="card">
        <div class="card-body p-2">
          <div class="row">
            <div class="pt-2 table-responsive">
                <table
                  datatable
                  id="DataTables_Table_0"
                  class="table-striped table-bordered mt-2 pt-2 table-sm small"
                  style="width: 100%">
                  <thead
                    class="top"
                    style="background-color: #624fd7; color: #ffffff">
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr *ngFor="let item of resourceLst">
                      <td></td>
                      <td>
                        <button class="btn btn-primary btn-sm"></button>
                      </td>
                    </tr> -->
                    <tr>
                        <td>2025 - 2026 Fees Structure</td>
                        <td>
                          <button class="btn btn-primary btn-sm">View</button>
                        </td>
                    </tr>
                    <tr>
                        <td>Faculity and Postgraduate Publication Spotlights</td>
                        <td>
                          <button class="btn btn-primary btn-sm">Download</button>
                        </td>
                    </tr>
                    <tr>
                        <td>HELB New Funding Model</td>
                        <td>
                          <button class="btn btn-primary btn-sm">Download</button>
                        </td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
            
        </div>
    </div>
  </div>
  <div class="modal-footer">
    <div>
      <button type="button" class="btn btn-danger" id="uploadModalCloseBtn" data-bs-dismiss="modal" (click)="actMdl.close()">
        Close
      </button>
      <!-- <button class="btn btn-sm btn-save" (click)="uploadMultiple(approveData)">
        Submit
      </button> -->
    </div>
  </div>
  
  <!-- <div class="modal" tabindex="-1" id="uploadModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <button type="button" class="btn-close" (click)="closeUploadModal()" id="uploadModalCloseBtn"
            data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <label for="">Upload:</label>
            <input type="file" #fileInputRef class="form-control pt-2" (change)="changeFile($event)" accept=".pdf,.PDF"
              multiple />
            <ul class="list-group mt-2" *ngIf="filesToUpload?.length">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of filesToUpload; let i = index">
                <a [href]="file.previewUrl" target="_blank" rel="noopener">{{
                  file.name
                  }}</a>
                <button type="button" class="btn btn-sm btn-danger" (click)="removeFile(i)">
                  Delete
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" id="uploadModalCloseBtn" data-bs-dismiss="modal"
            (click)="closeUploadModal()">
            Close
          </button>
          <button class="btn btn-sm btn-save" (click)="uploadMultiple(approveData)">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div> -->